import { withExtraArgument } from 'redux-thunk';
import { applyMiddleware, combineReducers, compose, createStore as _createStore, Reducer, StoreEnhancer } from 'redux';
import { IApplicationState, IReduxThunkContext, TReduxStore } from '../../types/redux';
import { IUser } from '../../types/user';
import { createSimpleReducer } from './createSimpleReducer';

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param debugEnabled boolean - режим дебага
 */
export function createReduxStore(initialState: IApplicationState, context: IReduxThunkContext, debugEnabled: boolean) {
  const reducers: Reducer<IApplicationState> = combineReducers({
    config: createSimpleReducer(initialState.config),
    projectData: createSimpleReducer(initialState.projectData),
    userData: createSimpleReducer<IUser | null>(null),
    showCallbackButton: createSimpleReducer(true),
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(withExtraArgument(context)),
  ) as unknown as StoreEnhancer;

  const createStore = (): TReduxStore => _createStore(reducers, initialState, storeEnchancers);

  return createStore();
}
